import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {DashboardContainer} from './components/layouts/MultipartyDashboardLayout';
import '@techsee/techsee-ui-common/lib/_shared/icons.css';
import './multipartyDashboard.scss';

interface MultipartyDashboardViewProps {
    multipartyDashboardStore?: any;
    rootStore?: any;
}

@observer
export class MultipartyDashboardViewComponent extends TechseeBaseComponent<MultipartyDashboardViewProps> {
    renderInternal(): JSX.Element {
        return <DashboardContainer />;
    }
}

export const MultipartyDashboardView = inject(
    'rootStore',
    'multipartyDashboardStore'
)(MultipartyDashboardViewComponent) as IReactComponent;
